"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCompactSliderProps = void 0;
const helpers_1 = require("../../Slider/helpers/helpers");
const COMPONENT_NAME = 'CompactSlider';
const checkCompactSliderProps = (startValue, minLimit, maxLimit, endValue, step) => {
    (0, helpers_1.baseCheckSliderMinMaxProps)({ min: minLimit, max: maxLimit, componentName: COMPONENT_NAME });
    if (minLimit < startValue) {
        throw new Error(`${COMPONENT_NAME} error: the argument "min" must be greater than or equal than "startValue".`);
    }
    if (maxLimit > endValue) {
        throw new Error(`${COMPONENT_NAME} error: the argument "max" must be smaller than or equal than "endValue".`);
    }
    (0, helpers_1.checkSliderStepProperty)({ min: minLimit, max: maxLimit, step, componentName: COMPONENT_NAME });
};
exports.checkCompactSliderProps = checkCompactSliderProps;
//# sourceMappingURL=checkCompactSliderProps.js.map